var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#13AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5144 19.7508C27.0932 13.4785 23.7344 11.4161 23.3728 10.6282C22.9772 10.0723 22.5765 9.0835 22.5765 9.0835C22.5699 9.0668 22.5593 9.03735 22.547 9.00879C22.5062 9.5647 22.4851 9.77915 21.9595 10.3399C21.1456 10.9762 16.9699 14.48 16.6302 21.6062C16.3134 28.2524 21.4312 32.2128 22.1234 32.7177L22.2021 32.7735V32.7687C22.2064 32.8021 22.4218 34.3507 22.5729 35.9917H23.1152C23.2425 34.8317 23.4332 33.6797 23.6865 32.5406L23.7305 32.5121C24.0401 32.2901 24.3352 32.0486 24.6142 31.7892L24.6459 31.7606C26.1171 30.4014 28.7622 27.2575 28.7363 22.2451C28.7308 21.409 28.6566 20.5747 28.5144 19.7508ZM22.5154 28.9652C22.5154 28.9652 22.5154 19.6436 22.823 19.6453C23.0629 19.6453 23.3736 31.6692 23.3736 31.6692C22.9465 31.6178 22.5154 29.6903 22.5154 28.9652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.b0574b335c02b30bf46778e09cfe515f.svg";
export { ForwardRef as ReactComponent };